export const TOKEN_TYPE = "Bearer ";
export const REQUEST_HEADER_AUTH_KEY = "Authorization";
export const REQUEST_HEADER_LOCALE_KEY = "Language";
